import React from "react";
import styles from "./Checkbox.module.scss";

export const Checkbox = ({
  value,
  onChange,
  title = "С удалением данных",
  id,
}) => {
  const uniqueId = `checkbox-${id}`;
  return (
    <div className={styles.container}>
      <input
        className={styles.checkboxInput}
        type="checkbox"
        id={id ? uniqueId : "checkbox"}
        checked={value}
        onChange={onChange}
      />
      <label
        htmlFor={id ? uniqueId : "checkbox"}
        className={styles.checkboxLabel}
      >
        <span className={styles.checkboxCustom}>
          {value && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={styles.checkboxIcon}
            >
              <path d="M20 6L9 17l-5-5" />
            </svg>
          )}
        </span>
        {title}
      </label>
    </div>
  );
};
